import { fetchPageData } from "../utils/fetch";

export const getActivities = async () => {
  const endpoint = "activities";
  const method = "GET";
  const err = "Failed to fetch activities.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateActivitie = async (token, activitieId, activitieData) => {
  const endpoint = activitieId ? `activitie/${activitieId}` : "activitie";
  const err = activitieId
    ? "Editing activitie failed."
    : "Creating activitie failed.";
  const method = activitieId ? "PUT" : "POST";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    activitieData
  );
  return fetchedData;
};

export const deleteActivitie = async (token, activitieId) => {
  const endpoint = `activitie/${activitieId}`;
  const method = "DELETE";
  const err = "Deleting activitie failed.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
